module.exports = __webpack_public_path__ + "img/burger-2.ac5b8925.jpg";